export default "__VITE_ASSET__DKNEAg_H__"